"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.absolute = void 0;
var _joi = _interopRequireDefault(require("joi"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const schema = _joi.default.string().uri({
  scheme: ['https'],
  allowRelative: true
});
const absolute = linkContent => {
  if (linkContent === undefined || !linkContent.url) {
    return '#';
  }
  const {
    error
  } = schema.validate(linkContent.url);
  if (error) {
    return '#';
  }
  if (linkContent.url && linkContent.url.indexOf('https://') === 0) {
    return linkContent.url;
  }
  const prefix = linkContent.url.indexOf('/') === 0 ? '' : '/';
  if (!linkContent.domain) {
    return `https://www.massmutual.com${prefix}${linkContent.url}`;
  }
  return `https://${linkContent.domain.title}${prefix}${linkContent.url}`;
};
exports.absolute = absolute;